/**
 * Mixin Transitions
 * allow us to call Loader's pageTransition
 * from our router-view transition
 */
import { until } from '@vueuse/core';
import loaderStore from 'components/ui/Loader/store';
import appStore from 'plugins/store/app';
import { nextTick, ref, Ref } from 'vue';

type Transition = (el: Element, done: () => void) => void;
type TransitionBefore = (el: Element) => void;

export default function():{
  beforeEnterTransition: TransitionBefore
  enterTransition: Transition
  leaveTransition: Transition
  ThePageTransition: Ref<any>;
} {
  const ThePageTransition = ref<Optional<any>>()

  /** leave old page */
  const leaveTransition:Transition = (el, done) => {
    loaderStore.setLoaded(false);
    appStore.setPageReady(false);
    nextTick(() => { // nexttick to let time to set timeline
      const {tlPageTransition} =  ThePageTransition.value

      if(!tlPageTransition) return done()

      // weird bug client reported on EMVI
      if(typeof tlPageTransition?.time !== 'function'){
         
        console.warn(`[transitions] unexpected - why tlPageTransition.time isn't a function ???`, tlPageTransition);
        return done()
      }

      const time = tlPageTransition.time()
      const end = tlPageTransition.labels.enter
      const delay = Math.max(end - time, 0) * 1000
      setTimeout(done, delay) // intro duration
    })
  }

  /** show new page */
  const beforeEnterTransition:TransitionBefore = () => {
    //
  };

  /** show new page */
  const enterTransition:Transition = (el, done) => {
    if (loaderStore.type !== 'transition') return done();
    until(appStore.ready()).toBe(true).then(() => {
      return done();
    })
  };

  return {
    beforeEnterTransition,
    enterTransition,
    leaveTransition,
    ThePageTransition,
  }
}
